export enum StatementPeriod {
  Year2024 = "2024",
  Archived = "archived"
}
